import React from "react";
import PropTypes from "prop-types";

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = { src: props.src };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.src !== nextProps.src) {
      this.setState({
        src: props.src
      });
    }
  }

  handleImageLoad() {
    // TODO Handle image loaded
  }

  handleImageError() {
    if (this.props.placeholder) {
      this.setState({ src: this.props.placeholder });
    }
  }

  handleOnContextMenu(e) {
    if (this.props.disableContextMenu) {
      e.preventDefault();
    }
  }

  render() {
    const { src, placeholder, disableContextMenu, ...other } = this.props; // es7

    return (
      <img
        src={this.state.src}
        onLoad={this.handleImageLoad.bind(this)}
        onError={this.handleImageError.bind(this)}
        {...other}
        onContextMenu={this.handleOnContextMenu.bind(this)}
      />
    );
  }
}

Image.defaultProps = {
  src: "",
  placeholder: "",
  disableContextMenu: false
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disableContextMenu: PropTypes.bool
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/Image.js